/**
 * Global logger bridge for use with webpack ProvidePlugin.
 * Delegates to window.logger (browser) or global.logger (Node/Jest).
 * Ensures the identifier "logger" is available in every module without explicit import.
 */
function getLogger() {
  if (typeof window !== 'undefined' && window.logger) return window.logger;
  if (typeof global !== 'undefined' && global.logger) return global.logger;
  return null;
}

const noop = () => {};
const fallback = {
  report: noop,
  error: noop,
  debug: noop,
  e: noop,
  w: noop,
  i: noop,
  kvl: noop,
  addMetaData: noop,
  logData: { send: noop }
};

export default new Proxy(fallback, {
  get(_, prop) {
    const logger = getLogger();
    const out = logger?.[prop] ?? fallback[prop];
    return typeof out === 'function' ? out.bind(logger || fallback) : out;
  }
});
